import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';

const HeroSection = () => {
  return (
    <Box
      id="home"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        position: 'relative',
        backgroundColor: '#1A1A1A',
        backgroundImage: 'url(/img/19.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        px: { xs: 4, md: 8, lg: 12 },
        py: 8,
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <Box>


          <Typography
            sx={{
              fontFamily: 'Oswald',
              fontSize: { xs: '64px', sm: '96px', md: '128px', lg: '160px' },
              fontWeight: 700,
              color: '#FFFFFF',
              letterSpacing: '0.05em',
              lineHeight: 0.9,
              mb: 1,
            }}
          >
            ARVIRA
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Oswald',
              fontSize: { xs: '64px', sm: '96px', md: '128px', lg: '160px' },
              fontWeight: 700,
              color: '#A8C5E8',
              letterSpacing: '0.05em',
              lineHeight: 0.9,
            }}
          >
            CREATIONS
          </Typography>
        </Box>
      </motion.div>

    </Box>
  );
};

export default HeroSection;
